import { ReactSVG } from "react-svg";
import { Button } from "@inntechcorp/it-design";
import { CloseButton, Content, PopContent, PopTitle, Wrapper } from "./styled";
import { ReactPortal, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { PopBottomSheetContainerProps } from "../context/PopBottomSheetContext";
import { GetLocalState } from "Connectivity/LocalStorage";
import { AssetReplacer } from "Helpers/replacer/AssetReplacer";

const POP_BOTTOM_SHEET_PORTAL_ID = "itd-pop-bottom-sheet-root";

const PopBottomSheetContainer = ({
  onHide,
  data
}:PopBottomSheetContainerProps):ReactPortal | null => {
  
  const [root,              SetRoot]              = useState<HTMLDivElement | null>(null);
  const [isOpen,            SetIsOpen]            = useState(false);
  const [hiddenAfterClose,  SetHiddenAfterClose]  = useState(true);

  useEffect(() => {
    if (data) {
      SetIsOpen(true);
      SetHiddenAfterClose(false);
    }
  }, [data]);

  useEffect(() => {

    if (!document.getElementById(POP_BOTTOM_SHEET_PORTAL_ID)) {

      let _root = document.createElement('div');
          _root.id = POP_BOTTOM_SHEET_PORTAL_ID;

      document.body.appendChild(_root);
      SetRoot(_root);

    }
    else {
      SetRoot(document.getElementById(POP_BOTTOM_SHEET_PORTAL_ID) as HTMLDivElement);
    }
  
    return(() => {
      if (root) document.body.removeChild(root);
    });
  
  }, []);

  const handleAnimationEnd = () => {
    if (!isOpen) {
      SetHiddenAfterClose(true);
      onHide();
    }
  };

  const getCloseButton = () => (
    <CloseButton>
      <Button
        variant     = "ghost"
        size        = "x-small"
        icon        = {<ReactSVG src={AssetReplacer(GetLocalState("assets").icons.GenericRoot + "close-simple.svg")} />}
        onClick     = {() => SetIsOpen(false)}
      >
      </Button>
    </CloseButton>
  );
  
  const getContent = () => (
    <Wrapper
      $isOpen={isOpen}
      onAnimationEnd={handleAnimationEnd}
      $hiddenAfterClose={hiddenAfterClose}
    >
      <Content $isOpen={isOpen}>
        <PopTitle>
          {data?.title}
          {getCloseButton()}
        </PopTitle>
        <PopContent>
          {data?.children}
        </PopContent>
      </Content>
    </Wrapper>
  )

  return root && data ? createPortal(getContent(), root) : null;

}

export default PopBottomSheetContainer;